import './Ssid.svelte.css';
/* src/Ssid.svelte generated by Svelte v3.37.0 */
import {
	SvelteComponent,
	action_destroyer,
	append,
	attr,
	detach,
	element,
	init as init_1,
	insert,
	listen,
	noop,
	prevent_default,
	run_all,
	safe_not_equal,
	set_data,
	set_input_value,
	set_style,
	space,
	text
} from "../_snowpack/pkg/svelte/internal.js";

import { getContext, createEventDispatcher } from "../_snowpack/pkg/svelte.js";

function create_else_block(ctx) {
	let t_value = /*ssid*/ ctx[0].esp_ssid + "";
	let t;

	return {
		c() {
			t = text(t_value);
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		p(ctx, dirty) {
			if (dirty & /*ssid*/ 1 && t_value !== (t_value = /*ssid*/ ctx[0].esp_ssid + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (79:2) {#if ssid.wfm_connection_dialog_open}
function create_if_block(ctx) {
	let div1;
	let t0;
	let br0;
	let t1;
	let b;
	let t2_value = /*ssid*/ ctx[0].esp_ssid + "";
	let t2;
	let t3;
	let br1;
	let t4;
	let form;
	let div0;
	let label;
	let t5;
	let br2;
	let t6;
	let input0;
	let init_action;
	let t7;
	let input1;
	let input1_disabled_value;
	let mounted;
	let dispose;

	return {
		c() {
			div1 = element("div");
			t0 = text("SSID:");
			br0 = element("br");
			t1 = space();
			b = element("b");
			t2 = text(t2_value);
			t3 = space();
			br1 = element("br");
			t4 = space();
			form = element("form");
			div0 = element("div");
			label = element("label");
			t5 = text("password:");
			br2 = element("br");
			t6 = space();
			input0 = element("input");
			t7 = space();
			input1 = element("input");
			attr(input0, "type", "password");
			attr(input0, "autocomplete", "123-let-me-in");
			attr(div0, "class", "form-inputs");
			attr(input1, "type", "submit");
			input1.disabled = input1_disabled_value = !/*can_connect*/ ctx[1];
			input1.value = "Connect!";
			attr(form, "action", "#");
			attr(div1, "class", "framed svelte-6uopac");
		},
		m(target, anchor) {
			insert(target, div1, anchor);
			append(div1, t0);
			append(div1, br0);
			append(div1, t1);
			append(div1, b);
			append(b, t2);
			append(div1, t3);
			append(div1, br1);
			append(div1, t4);
			append(div1, form);
			append(form, div0);
			append(div0, label);
			append(label, t5);
			append(label, br2);
			append(label, t6);
			append(label, input0);
			set_input_value(input0, /*password*/ ctx[2]);
			append(form, t7);
			append(form, input1);

			if (!mounted) {
				dispose = [
					action_destroyer(init_action = init.call(null, input0)),
					listen(input0, "input", /*input0_input_handler*/ ctx[8]),
					listen(form, "submit", prevent_default(/*connect2*/ ctx[6]))
				];

				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (dirty & /*ssid*/ 1 && t2_value !== (t2_value = /*ssid*/ ctx[0].esp_ssid + "")) set_data(t2, t2_value);

			if (dirty & /*password*/ 4 && input0.value !== /*password*/ ctx[2]) {
				set_input_value(input0, /*password*/ ctx[2]);
			}

			if (dirty & /*can_connect*/ 2 && input1_disabled_value !== (input1_disabled_value = !/*can_connect*/ ctx[1])) {
				input1.disabled = input1_disabled_value;
			}
		},
		d(detaching) {
			if (detaching) detach(div1);
			mounted = false;
			run_all(dispose);
		}
	};
}

function create_fragment(ctx) {
	let td0;
	let button;
	let t1;
	let td1;
	let t2;
	let td2;
	let t3_value = /*ssid*/ ctx[0].esp_signal + "";
	let t3;
	let t4;
	let td3;
	let t5_value = /*ssid*/ ctx[0].esp_chan + "";
	let t5;
	let t6;
	let td4;
	let t7_value = /*ssid*/ ctx[0].esp_enc_type + "";
	let t7;
	let t8;
	let td5;
	let t9_value = /*ssid*/ ctx[0].esp_bssid + "";
	let t9;
	let t10;
	let td6;
	let t11_value = /*ssid*/ ctx[0].wfm_last_seen_before + "";
	let t11;
	let t12;
	let td7;
	let details;
	let summary;
	let t14;
	let pre;
	let t15_value = JSON.stringify(/*ssid*/ ctx[0], null, " ") + "";
	let t15;
	let mounted;
	let dispose;

	function select_block_type(ctx, dirty) {
		if (/*ssid*/ ctx[0].wfm_connection_dialog_open) return create_if_block;
		return create_else_block;
	}

	let current_block_type = select_block_type(ctx, -1);
	let if_block = current_block_type(ctx);

	return {
		c() {
			td0 = element("td");
			button = element("button");
			button.textContent = "connect";
			t1 = space();
			td1 = element("td");
			if_block.c();
			t2 = space();
			td2 = element("td");
			t3 = text(t3_value);
			t4 = space();
			td3 = element("td");
			t5 = text(t5_value);
			t6 = space();
			td4 = element("td");
			t7 = text(t7_value);
			t8 = space();
			td5 = element("td");
			t9 = text(t9_value);
			t10 = space();
			td6 = element("td");
			t11 = text(t11_value);
			t12 = space();
			td7 = element("td");
			details = element("details");
			summary = element("summary");
			summary.textContent = "...";
			t14 = space();
			pre = element("pre");
			t15 = text(t15_value);
			attr(td1, "class", "row_clickable");
			attr(td2, "class", "row_clickable");
			set_style(td2, "background-color", "hsl(" + /*signal_hue*/ ctx[4] + ",100%,60%)");
			attr(td3, "class", "row_clickable");
			attr(td4, "class", "row_clickable");
			attr(td5, "class", "row_clickable");
			attr(td6, "class", "row_clickable");
			set_style(td6, "background-color", "hsl(" + 100 + "," + /*seen_sat*/ ctx[3] + "%,50%)");
		},
		m(target, anchor) {
			insert(target, td0, anchor);
			append(td0, button);
			insert(target, t1, anchor);
			insert(target, td1, anchor);
			if_block.m(td1, null);
			insert(target, t2, anchor);
			insert(target, td2, anchor);
			append(td2, t3);
			insert(target, t4, anchor);
			insert(target, td3, anchor);
			append(td3, t5);
			insert(target, t6, anchor);
			insert(target, td4, anchor);
			append(td4, t7);
			insert(target, t8, anchor);
			insert(target, td5, anchor);
			append(td5, t9);
			insert(target, t10, anchor);
			insert(target, td6, anchor);
			append(td6, t11);
			insert(target, t12, anchor);
			insert(target, td7, anchor);
			append(td7, details);
			append(details, summary);
			append(details, t14);
			append(details, pre);
			append(pre, t15);

			if (!mounted) {
				dispose = [
					listen(button, "click", /*connect*/ ctx[5]),
					listen(td1, "click", /*click_handler*/ ctx[9]),
					listen(td2, "click", /*click_handler_1*/ ctx[10]),
					listen(td3, "click", /*click_handler_2*/ ctx[11]),
					listen(td4, "click", /*click_handler_3*/ ctx[12]),
					listen(td5, "click", /*click_handler_4*/ ctx[13]),
					listen(td6, "click", /*click_handler_5*/ ctx[14])
				];

				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (current_block_type === (current_block_type = select_block_type(ctx, dirty)) && if_block) {
				if_block.p(ctx, dirty);
			} else {
				if_block.d(1);
				if_block = current_block_type(ctx);

				if (if_block) {
					if_block.c();
					if_block.m(td1, null);
				}
			}

			if (dirty & /*ssid*/ 1 && t3_value !== (t3_value = /*ssid*/ ctx[0].esp_signal + "")) set_data(t3, t3_value);

			if (dirty & /*signal_hue*/ 16) {
				set_style(td2, "background-color", "hsl(" + /*signal_hue*/ ctx[4] + ",100%,60%)");
			}

			if (dirty & /*ssid*/ 1 && t5_value !== (t5_value = /*ssid*/ ctx[0].esp_chan + "")) set_data(t5, t5_value);
			if (dirty & /*ssid*/ 1 && t7_value !== (t7_value = /*ssid*/ ctx[0].esp_enc_type + "")) set_data(t7, t7_value);
			if (dirty & /*ssid*/ 1 && t9_value !== (t9_value = /*ssid*/ ctx[0].esp_bssid + "")) set_data(t9, t9_value);
			if (dirty & /*ssid*/ 1 && t11_value !== (t11_value = /*ssid*/ ctx[0].wfm_last_seen_before + "")) set_data(t11, t11_value);

			if (dirty & /*seen_sat*/ 8) {
				set_style(td6, "background-color", "hsl(" + 100 + "," + /*seen_sat*/ ctx[3] + "%,50%)");
			}

			if (dirty & /*ssid*/ 1 && t15_value !== (t15_value = JSON.stringify(/*ssid*/ ctx[0], null, " ") + "")) set_data(t15, t15_value);
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(td0);
			if (detaching) detach(t1);
			if (detaching) detach(td1);
			if_block.d();
			if (detaching) detach(t2);
			if (detaching) detach(td2);
			if (detaching) detach(t4);
			if (detaching) detach(td3);
			if (detaching) detach(t6);
			if (detaching) detach(td4);
			if (detaching) detach(t8);
			if (detaching) detach(td5);
			if (detaching) detach(t10);
			if (detaching) detach(td6);
			if (detaching) detach(t12);
			if (detaching) detach(td7);
			mounted = false;
			run_all(dispose);
		}
	};
}

function clamp_color(x) {
	if (x < 0) return 0;
	if (x > 255) return 255;
	return x;
}

function clamp_sat(x) {
	if (x < 0) return 0;
	if (x > 100) return 100;
	return x;
}

function init(el) {
	el.focus();
}

function instance($$self, $$props, $$invalidate) {
	let seen_sat;
	let signal_hue;
	let { ssid } = $$props;
	let { can_connect } = $$props;
	const ws_send = getContext("ws_send");
	const dispatch = createEventDispatcher();

	function connect() {
		$$invalidate(0, ssid.wfm_connection_dialog_open = !ssid.wfm_connection_dialog_open, ssid);

		if (ssid.wfm_connection_dialog_open) {
			dispatch("close_other");
		}
	}

	function connect2() {
		const msg = {
			cmd: "connect",
			args: { "ssid": ssid.esp_ssid, "pass": password },
			"ts": new Date()
		};

		/*var xhr = new XMLHttpRequest();
xhr.open("POST", "http://" + ssid.host + "/command", true);
xhr.setRequestHeader('Content-Type', 'application/json');
xhr.send(JSON.stringify(msg));
 */
		ws_send(msg);
	}

	function td_click(e) {
		if (e.target.classList.contains("row_clickable")) connect();
	}

	let password = ssid.wfm_password;

	function input0_input_handler() {
		password = this.value;
		$$invalidate(2, password);
	}

	const click_handler = e => td_click(e);
	const click_handler_1 = e => td_click(e);
	const click_handler_2 = e => td_click(e);
	const click_handler_3 = e => td_click(e);
	const click_handler_4 = e => td_click(e);
	const click_handler_5 = e => td_click(e);

	$$self.$$set = $$props => {
		if ("ssid" in $$props) $$invalidate(0, ssid = $$props.ssid);
		if ("can_connect" in $$props) $$invalidate(1, can_connect = $$props.can_connect);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*password*/ 4) {
			$: $$invalidate(0, ssid.wfm_password = password, ssid);
		}

		if ($$self.$$.dirty & /*ssid*/ 1) {
			$: $$invalidate(3, seen_sat = clamp_sat(100 - ssid.wfm_last_seen_before / 300));
		}

		if ($$self.$$.dirty & /*ssid*/ 1) {
			/*RSSI is a percentage in the range -120db to 0db.
The closer to 0 the better.*/
			$: $$invalidate(4, signal_hue = 190 + ssid.esp_signal * 1.5);
		}
	};

	return [
		ssid,
		can_connect,
		password,
		seen_sat,
		signal_hue,
		connect,
		connect2,
		td_click,
		input0_input_handler,
		click_handler,
		click_handler_1,
		click_handler_2,
		click_handler_3,
		click_handler_4,
		click_handler_5
	];
}

class Ssid extends SvelteComponent {
	constructor(options) {
		super();
		init_1(this, options, instance, create_fragment, safe_not_equal, { ssid: 0, can_connect: 1 });
	}
}

export default Ssid;